import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/604a89e6887b9c9b2ae5c1388b8d77d0.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {t('hero_title')}
          </h1>
          <p className="text-xl md:text-2xl text-gray-100 mb-12 leading-relaxed">
            {t('hero_subtitle')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mb-4">
                <i className="ri-line-chart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white">{t('hero_feature1')}</h3>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mb-4">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white">{t('hero_feature2')}</h3>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mb-4">
                <i className="ri-map-pin-line text-3xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white">{t('hero_feature3')}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
